import moment from 'moment';

// One entry per department (rule 7): each /malha-fina/:department keeps its own filters.
export var getMalhaFinaFiltersKey = function(department) {
  return 'malhaFina:' + department;
};

// Year as a number: the year Select options and the default are numbers, so a
// string year ('2026') never matched and showed the default as a filter.
export var getDefaultMalhaFinaFilters = function() {
  return {
    year: moment().year(),
    search: '',
  };
};

export var toMalhaFinaYear = function(value, fallback) {
  var n = parseInt(value, 10);
  return isNaN(n) ? fallback : n;
};

export var normalizeMalhaFinaFilters = function(filters, defaults) {
  var f = filters || {};
  return {
    year: toMalhaFinaYear(f.year, defaults.year),
    search: typeof f.search === 'string' ? f.search : '',
  };
};

// Years offered in the Select: 2019 .. current year.
export var getMalhaFinaYearOptions = function(currentYear) {
  var back = currentYear - 2018;
  return Array.from({ length: back }, function(v, i) { return currentYear - back + i + 1; });
};

// Badge: only what differs from the defaults.
export var countActiveMalhaFinaFilters = function(filters, defaults) {
  return (filters.year !== defaults.year ? 1 : 0) + (filters.search ? 1 : 0);
};
